import React, { createContext } from 'react';
import { useDiContainer, useGlobalErrorsManager, useResolveController } from '../../hooks';
import { ErrorBoundary } from './ErrorBoundary';
import { Guards } from './Guards';
export var ControllerContext = /*#__PURE__*/createContext(undefined);
export var ControllerWrapper = function ControllerWrapper(_ref) {
  var Controller = _ref.Controller;
  var ctrl = useResolveController(Controller);
  var container = useDiContainer();
  var globalErrorsManager = useGlobalErrorsManager();
  var _ctrl$__controller__ = ctrl.__controller__,
      View = _ctrl$__controller__.view,
      _ctrl$__controller__$ = _ctrl$__controller__.guards,
      guards = _ctrl$__controller__$ === void 0 ? [] : _ctrl$__controller__$,
      _ctrl$__controller__$2 = _ctrl$__controller__.handlers,
      handlers = _ctrl$__controller__$2 === void 0 ? [] : _ctrl$__controller__$2;
  var eh = handlers.map(function (v) {
    return typeof v === 'function' ? container.resolveDepsSync(v) : v;
  });
  var gs = guards.map(function (G) {
    return container.resolveSync(G);
  });
  return /*#__PURE__*/React.createElement(ControllerContext.Provider, {
    value: ctrl
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    name: Controller.name,
    globalErrorsManager: globalErrorsManager,
    handlers: eh
  }, /*#__PURE__*/React.createElement(Guards, {
    guards: gs
  }, /*#__PURE__*/React.createElement(View, null))));
};